import { HGO_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/leaflets
    */
    getLeaflets: function(options){
        return axios.get( HGO_CONFIG.API_URL + '/leaflets',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
        }});
    },

    /*
        GET     /api/leaflets/search
    */
   searchLeaflets: function(options){
    return axios.get( HGO_CONFIG.API_URL + '/leaflets/search',{
        params:{
            showDeleted:options.showDeleted,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

    /*
		POST 	/api/leaflets
	*/
    postAddNewLeaflet: function( name,description,file_name,file_content,file_type){
        return axios.post( HGO_CONFIG.API_URL + '/leaflets',
            {
                name: name,
                description:description,
                file_name:file_name,
                file_content:file_content,
                file_type:file_type
            }
        );
    },

    /*
		GET 	/api/leaflets/{slug}/edit
	*/
    getLeafletEdit: function( slug ){
		return axios.get( HGO_CONFIG.API_URL + '/leaflets/' + slug + '/edit' );
	},


    /*
		PUT 	/api/leaflets/{slug}
	*/
    putEditLeaflet: function(slug, name,description,file_name,file_content,file_type){
        return axios.put( HGO_CONFIG.API_URL + '/leaflets/'+ slug,
            {
                name: name,
                description:description,
                file_name:file_name,
                file_content:file_content,
                file_type:file_type
            }
        );
    },

     /*
		GET 	/api/leaflets/reactivate/{slug}
	*/
    putReactivateLeaflet: function(slug){
        return axios.get( HGO_CONFIG.API_URL + '/leaflets/reactivate/' + slug);
    },

    /*
		DELETE /api/leaflets/{slug}
	*/
    deleteLeaflet: function( slug ){
		return axios.delete( HGO_CONFIG.API_URL + '/leaflets/' + slug );
    },
    
    /*
		DELETE /api/leaflets/{slug}/force
	*/
    forceDeleteLeaflet: function( slug ){
		return axios.delete( HGO_CONFIG.API_URL + '/leaflets/' + slug + '/force' );
	}
}